import { render } from "./authenticated.vue?vue&type=template&id=1697b73a&scoped=true"
import script from "./authenticated.vue?vue&type=script&setup=true&lang=js"
export * from "./authenticated.vue?vue&type=script&setup=true&lang=js"

import "./authenticated.vue?vue&type=style&index=0&id=1697b73a&scoped=true&lang=css"

import exportComponent from "/var/www/vhosts/pqv3/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1697b73a"],['__file',"resources/js/views/layouts/authenticated.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "1697b73a"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('1697b73a', __exports__)) {
    console.log('reload')
    api.reload('1697b73a', __exports__)
  }
  
  module.hot.accept("./authenticated.vue?vue&type=template&id=1697b73a&scoped=true", () => {
    console.log('re-render')
    api.rerender('1697b73a', render)
  })

}


export default __exports__